import React, { useState } from 'react';
import { useAuth } from "../../context/DBContext";
import { useNavigate } from "react-router-dom";

export default function EmailVerificationPage() {
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const { sendEmailVerification, logout, currentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function resendEmail(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      await sendEmailVerification();
      setSuccess("Email sent again");
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }

  if (currentUser && currentUser.emailVerified) {
    navigate("/");
  }

  async function handleLogout() {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      // console.error('Failed to log out:', error);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-gray-100 p-3">
      <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-lg shadow-xl p-6 max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">Email Verification Sent</h2>
        <p className="text-sm text-gray-600 text-center mb-6">
          Please check your email inbox. A verification email has been sent.
        </p>

        {error && (
          <div className="mb-4 text-center text-red-600 text-sm bg-red-100 border border-red-400 rounded-md p-2">
            {error}
          </div>
        )}
        {success && (
          <div className="mb-4 text-center text-green-600 text-sm bg-green-100 border border-green-400 rounded-md p-2">
            {success}
          </div>
        )}

        <form onSubmit={resendEmail} className="space-y-4">
          <button
            type="submit"
            disabled={loading}
            className={`w-full flex justify-center items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
              loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'
            } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            {loading ? 'Sending...' : 'Resend Email'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <button
            onClick={handleLogout}
            className="text-sm text-blue-600 hover:underline flex items-center justify-center mx-auto"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            Go back to Login
          </button>
        </div>
      </div>

      <footer className="fixed bottom-0 w-full py-4 bg-gray-100 bg-opacity-70 backdrop-blur-sm">
        <div className="container mx-auto px-4">
         
          <div className="text-center text-xs text-gray-600">
            &copy; 2024, <span>enableSEND</span>
          </div>
        </div>
      </footer>
    </div>
  );
}